// ShopMy channel — creator-attributed orders (an attribution lens over
// barsys.com orders, served by /secureApi/analytics/shopmy/*; deliberately
// excluded from the US totals on the backend).
import axios from "axios";
import {
  FETCH_SHOPMY_ORDERS_LOADING,
  FETCH_SHOPMY_ORDERS_SUCCESS,
  FETCH_SHOPMY_ORDERS_FAIL,
} from "./types";

const BASE = () =>
  `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/shopmy`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
});

// ---------------------------------------------------------------------------
// Orders table (paginated) — GET /orders/paginated-by-range
// ---------------------------------------------------------------------------
export const fetchShopmyOrders =
  (page = 1, perPage = 20, searchTerm = "", range = "30 days") =>
  async (dispatch) => {
    dispatch({ type: FETCH_SHOPMY_ORDERS_LOADING });
    try {
      const resp = await axios.get(`${BASE()}/orders/paginated-by-range`, {
        headers: authHeaders(),
        params: {
          range,
          page,
          perPage,
          ...(searchTerm ? { searchTerm } : {}),
        },
      });
      if (resp.data?.success) {
        dispatch({
          type: FETCH_SHOPMY_ORDERS_SUCCESS,
          payload: {
            orders: resp.data.orders || [],
            totalOrders: resp.data.totalOrders || 0,
          },
        });
      } else {
        dispatch({
          type: FETCH_SHOPMY_ORDERS_FAIL,
          payload: resp.data?.message || "Failed to fetch ShopMy orders",
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_SHOPMY_ORDERS_FAIL,
        payload:
          err.response?.data?.message || err.message || "Failed to fetch ShopMy orders",
      });
    }
  };
